import { FC, useState } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useHistory } from 'react-router';
import { observer } from 'mobx-react-lite';
import { ConfirmActionDialog } from 'components/Dialogs';
import { GridColumns, DataGrid, GridCellParams } from '@material-ui/data-grid';
import IconButton from '@material-ui/core/IconButton';
import BusinessIcon from '@material-ui/icons/Business';
import EditIcon from '@material-ui/icons/Edit';
import { Paper } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from './styles';
import PreviewIcon from '@material-ui/icons/RemoveRedEyeSharp';
import { orange } from '@material-ui/core/colors';

export const DepartmentsTable: FC = observer(() => {
  const history = useHistory();
  const classes = useStyles();

  const {
    ldapStore: { departmentsView, getDepartments, setClickedDepartment, deleteDepartment },
    notificationStore: { openNotification },
  } = useStore();

  const [appStatus, setAppStatus] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);

  const getDepartmentsReq = useQuery('getDepartmentsReq', () => getDepartments(), {
    onError: () => openNotification('error', `Can't get departments`),
  });
  const status = 'delete';
  const deleteDepartmentReq = useMutation(() => deleteDepartment(status, appStatus), {
    mutationKey: 'deleteDepartmentsReq',
    onSuccess: () => {
      openNotification('success', `Deleted succcessfully`);
      getDepartmentsReq.refetch();
    },
    onError: () => openNotification('error', `Department cannot be deleted.`),
  });

  useAppPreloader(getDepartmentsReq.isFetching || deleteDepartmentReq.isLoading);

  const columns: GridColumns = [
    {
      field: 'icon',
      headerName: ' ',
      align: 'center',
      width: 40,
      renderCell: (params: GridCellParams) => <BusinessIcon />,
    },
    { field: 'ou', headerName: 'DEPARTMENT', flex: 0.5 },
    { field: 'description', headerName: 'DESCRIPTION', flex: 1 },
    // { field: 'dn', headerName: 'DN', flex: 1 },
    {
      field: 'options',
      headerName: 'ACTIONS',
      width: 100,
      align: 'center',
      disableColumnMenu: true,
      renderCell: (params: GridCellParams) => (
        <>
          <IconButton size='small' onClick={() => history.push('/department/view')}>
            <PreviewIcon style={{ color: orange[500] }} />
          </IconButton>
          <IconButton size='small' onClick={() => history.push('/department/edit')}>
            <EditIcon style={{ fill: '#FF9800' }} />
          </IconButton>
          <IconButton size='small' onClick={() => setOpenConfirmDialog(true)}>
            <DeleteIcon style={{ fill: '#F44336' }} />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          rows={!getDepartmentsReq.isFetching ? departmentsView : []}
          columns={columns}
          checkboxSelection
          onCellClick={(event: GridCellParams) => setClickedDepartment(event.row.dn)}
        />
      </Paper>
      <ConfirmActionDialog
        label='Delete Department'
        appnotify={appStatus}
        gitStatus=''
        appnotifyStatus={setAppStatus}
        buttonLabel='Confirm'
        openModal={openConfirmDialog}
        action={() => deleteDepartmentReq.mutate()}
        handleClose={() => {
          setOpenConfirmDialog(false);
          setAppStatus(true);
        }}
      />
    </>
  );
});
